import * as XLSX from "xlsx/xlsx.mjs";

const exportContactDataToXls = (
  item,
  personalData,
  contactData,
  socialData,
  contactEntities,
  asesors
) => {
  // Información del contacto (puedes obtenerla de un objeto dinámico)
  const contact = {
    nombres: item?.first_name,
    apellidos: item?.last_name,
    cargo: item?.charge?.name,
    jurisdiccion: personalData?.jurisdiccion?.name,
    "espacio politico": personalData?.politic_space?.name,
    distrito: personalData?.district?.name,
    bloque: personalData?.block?.name,
    "fecha inicio de mandato": personalData?.charge_start_at,
    "fecha fin de mandato": personalData?.charge_end_at,
    "url de perfil": personalData?.profile_url,
    "email 1": contactData?.email_1,
    "whatsapp 1 ": contactData?.whatsapp_1,
    "email 2": contactData?.email_2,
    "whatsapp 2": contactData?.whatsapp_2,
    "email 3": contactData?.email_3,
    "whatsapp 3 ": contactData?.whatsapp_3,
    facebook: socialData?.facebook_url,
    "sitio web": socialData?.website_url,
    instagaram: socialData?.instagaram_url,
    "instagram username": socialData?.instagaram_username,
    twitter: socialData?.twitter_url,
    "twitter username": socialData?.twitter_username,
    "linkedin url": socialData?.linkedin_url,
    entidades: contactEntities.map((entity) => entity.name).join(", "),
    comisiones: item?.comissions
      .map((comission) => `${comission.name} - ${comission.district?.name}`)
      .join(", "),
  };

  // Create a workbook from the worksheet
  const wb = XLSX.utils.book_new();

  // Dynamically create the data array based on the keys in the contact object
  const contact_data = Object.keys(contact).map((key) => ({
    Campo: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize the first letter of the field name
    Valor: contact[key], // Use the value of the corresponding key in contactData
  }));

  // Create a worksheet from the contact data
  const contactSheet = XLSX.utils.json_to_sheet(contact_data);

  XLSX.utils.book_append_sheet(wb, contactSheet, "Contacto");

  let asesors_array = asesors.map((asesor) => {
    return {
      nombre: asesor.first_name,
      apellido: asesor.last_name,
      cargo: asesor?.charge?.name,
      area: asesor?.area?.name,
      email: asesor.email,
      telefono: asesor.phone,
      whatsapp: asesor.whatsapp,
      linkedin: asesor.linkedin_url,
      facebook: asesor.facebook_url,
      twitter: asesor.twitter_url,
      twitter_username: asesor.twitter_username,
      instagram: asesor.instagram_url,
      instagram_username: asesor.instagram_username,
    };
  });

  // Create a worksheet from the contact data
  const asesorsSheet = XLSX.utils.json_to_sheet(asesors_array);

  XLSX.utils.book_append_sheet(wb, asesorsSheet, "Asesores");

  // Export the Excel file
  XLSX.writeFile(wb, "contact.xlsx");
};

export default exportContactDataToXls;
